import React from "react";
import "./index.css";
import { Link } from "react-router-dom";

const Card = ({ image, title, description, link }) => {
  return (
    <Link to={`/service_detail?name=${link}`}>
      <div
        className="relative isolate flex flex-col justify-end overflow-hidden rounded-md md:mx-3 px-8 pb-12 h-[250px]  pt-40 max-w-[250px] mx-auto mt-12   shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl

"
      >
        <img
          className="absolute inset-0 h-full w-full object-cover object-center   transition duration-300 ease-in-out transform group-hover:scale-110"
          src={image}
          alt={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <h3 className="z-10 -mb-4 text-xl  font-bold text-white">{title}</h3>
        <div className="z-10 gap-y-1 overflow-hidden text-sm  text-gray-300">
          {description}
        </div>
      </div>
    </Link>
  );
};

export default Card;
